import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetLogoComponent } from './widget-logo/widget-logo.component';
import { WidgetStepLogoComponent } from './widget-step-logo/widget-step-logo.component';
import { TermsAndPolicyLinksComponent } from './terms-and-policy-links/terms-and-policy-links.component';
import { OtpStepComponent } from './otp-step/otp-step.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SafeHtmlModule } from 'src/pipes/safe-html.module';
import { MaterialModule } from '../modules/materia.module';
import { CancelRequestComponent } from './cancel-request/cancel-request.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { AppImageLoaderComponent } from './app-image-loader/app-image-loader.component';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  declarations: [
    WidgetLogoComponent,
    WidgetStepLogoComponent,
    TermsAndPolicyLinksComponent,
    OtpStepComponent,
    CancelRequestComponent,
    AppImageLoaderComponent,
  ],
  imports: [
    CommonModule,
    SafeHtmlModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    NgxMaskModule.forChild(),
  ],
  exports: [
    WidgetLogoComponent,
    WidgetStepLogoComponent,
    TermsAndPolicyLinksComponent,
    OtpStepComponent,
    CancelRequestComponent,
    AppImageLoaderComponent,
    NgxMaskModule,
  ]
})
export class SharedComponentsModule { }